var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreeen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 13.9987H23.3334M21 16.332V11.6654M4.66669 20.9987V19.832C4.66669 18.9038 5.03544 18.0135 5.69181 17.3572C6.34819 16.7008 7.23843 16.332 8.16669 16.332H12.8334C13.7616 16.332 14.6518 16.7008 15.3082 17.3572C15.9646 18.0135 16.3334 18.9038 16.3334 19.832V20.9987C16.3334 21.3081 16.2104 21.6049 15.9916 21.8237C15.7729 22.0424 15.4761 22.1654 15.1667 22.1654H5.83335C5.52393 22.1654 5.22719 22.0424 5.0084 21.8237C4.7896 21.6049 4.66669 21.3081 4.66669 20.9987ZM14 9.33203C14 10.2603 13.6313 11.1505 12.9749 11.8069C12.3185 12.4633 11.4283 12.832 10.5 12.832C9.57176 12.832 8.68152 12.4633 8.02515 11.8069C7.36877 11.1505 7.00002 10.2603 7.00002 9.33203C7.00002 8.40377 7.36877 7.51353 8.02515 6.85716C8.68152 6.20078 9.57176 5.83203 10.5 5.83203C11.4283 5.83203 12.3185 6.20078 12.9749 6.85716C13.6313 7.51353 14 8.40377 14 9.33203Z",
    stroke: "#1FA541",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeen);
export default __webpack_public_path__ + "static/media/Greeen.8a1dc8026eeef397d06886932043507f.svg";
export { ForwardRef as ReactComponent };